var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import manualAssetUpdate from '../../requests/asset/manualAssetUpdate';
import manualAssetDataUpdate from '../../requests/asset/manualAssetDataUpdate';
/**
 *
 */
var UpdateManualAssetDataCommand = /** @class */ (function (_super) {
    __extends(UpdateManualAssetDataCommand, _super);
    function UpdateManualAssetDataCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param manualAssetModel ManualAssetModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    UpdateManualAssetDataCommand.prototype.execute = function (manualAssetModel, organisationId, intl) {
        var obj = {};
        // Als 1 vd velden null is will de api dat het object op null wordt gezet.
        Object.keys(manualAssetModel).forEach(function (key) {
            switch (key) {
                // Check if valid values,
                case 'location':
                    if ((manualAssetModel.location.latitude == null || manualAssetModel.location.latitude === 0) ||
                        (manualAssetModel.location.longitude == null || manualAssetModel.location.longitude === 0) ||
                        manualAssetModel.location.timestamp == null) {
                        obj[key] = null;
                    }
                    else {
                        obj[key] = manualAssetModel[key];
                    }
                    break;
                case "fuelUsedInLiters":
                    if (manualAssetModel.fuelUsedInLiters.timestamp == null || manualAssetModel.fuelUsedInLiters.value == null) {
                        obj[key] = null;
                    }
                    else {
                        obj[key] = manualAssetModel[key];
                    }
                    break;
                case 'cumulativeOperatingHoursValue':
                    if (manualAssetModel.cumulativeOperatingHoursValue.timestamp == null || manualAssetModel.cumulativeOperatingHoursValue.value == null) {
                        obj[key] = null;
                    }
                    else {
                        obj[key] = manualAssetModel[key];
                    }
                    break;
                default:
                    obj[key] = manualAssetModel[key];
            }
        });
        this.intl = intl;
        this.manualAssetModel = manualAssetModel;
        var promise = manualAssetUpdate(obj, organisationId)
            .then(function (_) { return manualAssetDataUpdate(obj, organisationId); });
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    UpdateManualAssetDataCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.asset.updated' }, Object(this.manualAssetModel)), 'dark', true);
    };
    return UpdateManualAssetDataCommand;
}(Command));
export default UpdateManualAssetDataCommand;
